module.exports = __webpack_public_path__ + "static/img/new-3.5df1d7b1.jpg";